import type { ApiConfig } from '../../types'

export const perpsFundingHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'perps-funding-history',
} as const satisfies ApiConfig
